import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { breakpoint } from '~/theme';

const Column = styled.div`
    ${({
        span,
        spanLargePhone,
        spanTablet,
        spanLargeTablet,
        spanDesktop,
        start,
        startLargePhone,
        startTablet,
        startLargeTablet,
        startDesktop
    }) => `
        width: 100%;
        ${span ? `grid-column: auto / span ${span};` : ''}
        ${start ? `grid-column-start: ${start};` : ''}
        ${
            spanLargePhone
                ? `@media (min-width: ${breakpoint.largePhone}) { 
            grid-column: auto / span ${spanLargePhone}; 
        }`
                : ''
        }
        ${
            startLargePhone
                ? `@media (min-width: ${breakpoint.largePhone}) { 
            grid-column-start: ${startLargePhone}; 
        }`
                : ''
        }
        ${
            spanTablet
                ? `@media (min-width: ${breakpoint.tablet}) { 
            grid-column: auto / span ${spanTablet}; 
        }`
                : ''
        }
        ${
            startTablet
                ? `@media (min-width: ${breakpoint.tablet}) { 
            grid-column-start: ${startTablet}; 
        }`
                : ''
        }
        ${
            spanLargeTablet
                ? `@media (min-width: ${breakpoint.largeTablet}) { 
            grid-column: auto / span ${spanLargeTablet}; 
        }`
                : ''
        }
        ${
            startLargeTablet
                ? `@media (min-width: ${breakpoint.largeTablet}) { 
            grid-column-start: ${startLargeTablet}; 
        }`
                : ''
        }
        ${
            spanDesktop
                ? `@media (min-width: ${breakpoint.desktop}) { 
            grid-column: auto / span ${spanDesktop}; 
        }`
                : ''
        }
        ${
            startDesktop
                ? `@media (min-width: ${breakpoint.desktop}) { 
            grid-column-start: ${startDesktop}; 
        }`
                : ''
        }
`}
`;

Column.propTypes = {
    span: PropTypes.number,
    spanLargePhone: PropTypes.number,
    spanTablet: PropTypes.number,
    spanLargeTablet: PropTypes.number,
    spanDesktop: PropTypes.number,
    start: PropTypes.number,
    startLargePhone: PropTypes.number,
    startTablet: PropTypes.number,
    startLargeTablet: PropTypes.number,
    startDesktop: PropTypes.number
};

export default Column;
